import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { TradingOfferTimelineStep } from '../../../../../types/TradingOffer';

type TradingOfferTimelineProps = {
  steps: TradingOfferTimelineStep[];
};

const TradingOfferTimeline: FC<TradingOfferTimelineProps> = ({ steps }) => {
  const { t } = useTranslate();

  const getStepClass = (step: TradingOfferTimelineStep) => {
    if (step.isCompleted) return 'done';
    if (step.isCurrent) return 'current';
    return '';
  };

  return (
    <div className="card card-bordered mb-4">
      <div className="card-inner">
        <h6 className="card-title mb-3">
          <em className="icon ni ni-list-check text-primary mr-2" />
          {t('OfferTimeline')}
        </h6>

        <ul className="nk-stepper-nav list-unstyled mb-0">
          {steps.map((step) => (
            <li
              key={step.key}
              className={`step-item ${getStepClass(
                step
              )} bg-white d-flex flex-column flex-grow-1 align-items-center px-1`}
            >
              <div className="step-icon m-0 mb-2">
                <em className={`icon ni ${step.icon || 'ni-check'}`} />
              </div>
              <div className="step-text text-center">
                <div className="step-title">{t(step.label)}</div>
                {step.date && <div className="step-subtitle">{step.date}</div>}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TradingOfferTimeline;
